import { Browse } from 'spa/components/browse'
import { Layout, Sidebar } from 'spa/components/layout'
import Global from './global'
import React from 'react'

const display = () => {
  return (
    <Layout tabTitle="global_songs">
      <Sidebar>
        <Browse />
      </Sidebar>
      <Global />
    </Layout>
  )
}

export { display as GlobalDisplay }

export { Global }

export default Global
